export default "__VITE_ASSET__C1PG8sg5__"